import { setTrackSceneSource } from "./src/analytics.js";

export const tourFunctions = {};
/*____________ Tour Functions ____________*/
tourFunctions.enterVr = () => {
  window.CC.krpano.call("webvr.enterVR();");
};

tourFunctions.setStopUrl = (scene = null) => {
  if (!scene) {
    scene = tourFunctions.currentScene.getScene();
  }
  const sceneIndex = scene.index + 1;
  const url = window.location.href.split("?")[0].split("#")[0];
  const scenePath = `/stop/${sceneIndex}`;
  window.location.hash = scenePath;
}

tourFunctions.setHotspotUrl = (hotspotId) => {
  if( !hotspotId ) return;
  const url = window.location.href.split("?")[0].split("#")[0];
  const hotspotPath = `/hotspot/${hotspotId}`;
  window.location.hash = hotspotPath;
}

tourFunctions.focus = () => {
  document.querySelector("#krpanoSWFObject").focus();
};

tourFunctions.convertColor = (color) => {
  color = color || "0x000000";
  if (color.startsWith("#")) {
    color = "0x" + color.slice(1);
  }
  return color;
};

tourFunctions.getScenes = () => {
  const scenes = window.CC.krpano.get("scene").getArray();
  return scenes;
};

tourFunctions.switchView = () => {
  expandedTour = !expandedTour;
  expandedMap = !expandedMap;
  expandedTour ? showHotspots() : hideHotspots();
  setMapZoom();
};

tourFunctions.setMapZoom = () => {
  let zoomExpandedMap = 16.75;
  let zoomMiniMap = 15;
  let zoomLevel = expandedMap ? zoomExpandedMap : zoomMiniMap;
  tourFunctions.mapZoom.set(zoomLevel);
  return zoomLevel;
};

tourFunctions.showHotspots = () => {
  console.log("show_hotspots");
  window.CC.krpano.call(
    "for(copy(i,hotspot.count), i GE 0, dec(i), set(hotspot[get(i)].visible, true); );"
  );
};

tourFunctions.hideHotspots = () => {
  console.log("hide_hotspots");
  window.CC.krpano.call(
    "for(copy(i,hotspot.count), i GE 0, dec(i), set(hotspot[get(i)].visible, false); );"
  );
};

/** Restores hotspots deferred until the tutorial overlay (no little-planet intro). */
tourFunctions.showIntroHotspotsFromTutorial = () => {
  window.CC?.krpano?.call("reveal_intro_hs();");
};

tourFunctions.setBrowserLocationWithSceneIndex = () => {
  const sceneIndex = window.CC.krpano.get("scene[get(xml.scene)].index") + 1;
  const url = window.location.href.split("?")[0].split("#")[0];
  const scenePath = `#/stop/${sceneIndex}`;
  // Replace the Location URL
  window.history.replaceState(null, "", `${url}${scenePath}`);
};

tourFunctions.getSceneIndexFromBrowserLocation = () => {
  const sceneIndex = window.location.hash.split("/")[2];
  return sceneIndex;
};

function sanitizeTourQueryString(value) {
  return value.replace(/[^\w\s\-,]/g, "");
}

tourFunctions.getQueryStrings = (
  allowed = ["startscene", "location", "ada", "scenes"],
) => {
  if (typeof window === "undefined") return {};
  const urlParams = new URLSearchParams(window.location.search);
  const queryStrings = {};
  for (const key of allowed) {
    if (!urlParams.has(key)) continue;
    const value = urlParams.get(key);
    if (value === "false") {
      queryStrings[key] = false;
    } else if (value === "true" || value === "") {
      queryStrings[key] = true;
    } else {
      queryStrings[key] = sanitizeTourQueryString(value);
    }
  }
  return queryStrings;
};

/**
 * Resolve the visible-scene index krpano should start on (URL hash, query, hotspot).
 */
tourFunctions.getStartSceneIndex = (tour, options = {}) => {
  const visibleScenes = tour?.scenes?.filter((scene) => !scene.hidden) ?? [];
  const stopHash =
    typeof window !== "undefined"
      ? window.location.hash.split("/stop/")[1]
      : null;
  const hotspotHash =
    typeof window !== "undefined"
      ? window.location.hash.match(/^#\/hotspot\/(.+)$/)
      : null;
  const hotspotId = options.hotspotId ?? (hotspotHash ? hotspotHash[1] : null);
  const queryStrings =
    options.queryStrings ?? tourFunctions.getQueryStrings();
  const startscene =
    queryStrings.startscene != null && queryStrings.startscene !== true
      ? String(queryStrings.startscene)
      : null;
  const location =
    queryStrings.location != null && queryStrings.location !== true
      ? String(queryStrings.location)
      : null;
  const hotspotIdStr = hotspotId != null ? String(hotspotId) : null;

  let startSceneIndex = parseInt(stopHash, 10) - 1;
  if (isNaN(startSceneIndex) || startSceneIndex < 0) startSceneIndex = 0;

  if (startscene || location || hotspotIdStr) {
    const sceneIndex = visibleScenes.findIndex((scene) => {
      const isId = startscene && String(scene.id) === startscene;
      const isName = startscene && String(scene.name) === startscene;
      const isSlug =
        (location && String(scene.slug) === location) ||
        (location && String(scene.name) === location);
      if (hotspotIdStr) {
        const isHotspot = scene.hotspots?.find(
          (hs) => String(hs.id) === hotspotIdStr,
        );
        return isId || isName || isSlug || isHotspot;
      }
      return isId || isName || isSlug;
    });

    if (sceneIndex !== -1) startSceneIndex = sceneIndex;
  }

  return Math.min(
    Math.max(0, startSceneIndex),
    Math.max(0, visibleScenes.length - 1),
  );
};

tourFunctions.nextSceneLoop = (direction, trackingSource = 'navigation') => {
  const slideDirection = (direction === 1) ? 0 : 180;
  
  // Check if current scene is valid and there is more than one scene
  if (window.CC.krpano.get('xml.scene') != null && window.CC.krpano.get('scene.count') > 1) {
    const currentSceneIndex = window.CC.krpano.get('scene[' + window.CC.krpano.get('xml.scene') + '].index');
    const sceneCount = window.CC.krpano.get('scene.count');
    let newSceneIndex = currentSceneIndex + direction;
    const lastSceneIndex = sceneCount - 1;

    // Helper function to find the next valid scene that isn't hidden
    const findNextVisibleScene = (index, dir) => {
      while (window.CC.krpano.get('scene[' + index + '].burried') == "true") {
        index += dir;
        if (index < 0) {
          index = lastSceneIndex; // Wrap to last scene
        }
        if (index > lastSceneIndex) {
          index = 0; // Wrap to first scene
        }
      }
      return index;
    };

    // Wrap the newSceneIndex if out of bounds and find the next visible scene
    if (newSceneIndex < 0) {
      newSceneIndex = lastSceneIndex;
    }
    if (newSceneIndex > lastSceneIndex) {
      newSceneIndex = 0;
    }

    newSceneIndex = findNextVisibleScene(newSceneIndex, direction);

    // Get the scene name and load it using our existing loadScene function
    const sceneName = window.CC.krpano.get('scene[' + newSceneIndex + '].name');
    const scene = { name: sceneName };
    
    // Set tracking source and load the scene with sliding effect
    window.CC.pendingSceneSource = trackingSource;
    window.CC.krpano.call(
      `loadscene(${sceneName}, null, MERGE, SLIDEBLEND(1.0, ${slideDirection}, 0.5, linear))`
    );
  }
};

tourFunctions.nextSceneLoopWithOrder = (direction, trackingSource = 'navigation', sceneOrder) => {
  const slideDirection = (direction === 1) ? 0 : 180;
  
  // Check if current scene is valid and there is more than one scene
  if (window.CC.krpano.get('xml.scene') != null && sceneOrder && sceneOrder.length > 1) {
    const currentSceneName = window.CC.krpano.get('xml.scene');
    const currentSceneIndex = sceneOrder.findIndex(scene => scene.name === currentSceneName);
    
    if (currentSceneIndex === -1) {
      // Current scene not in custom order, fall back to default behavior
      tourFunctions.nextSceneLoop(direction, trackingSource);
      return;
    }
    
    let newSceneIndex = currentSceneIndex + direction;
    const lastSceneIndex = sceneOrder.length - 1;

    // Helper function to find the next valid scene that isn't buried
    const findNextVisibleScene = (index, dir) => {
      while (index >= 0 && index < sceneOrder.length && sceneOrder[index].burried === true) {
        index += dir;
        if (index < 0) {
          index = lastSceneIndex; // Wrap to last scene
        }
        if (index > lastSceneIndex) {
          index = 0; // Wrap to first scene
        }
      }
      return index;
    };

    // Wrap the newSceneIndex if out of bounds
    if (newSceneIndex < 0) {
      newSceneIndex = lastSceneIndex;
    }
    if (newSceneIndex > lastSceneIndex) {
      newSceneIndex = 0;
    }

    // Find the next visible (non-buried) scene
    newSceneIndex = findNextVisibleScene(newSceneIndex, direction);

    // Get the scene name from the custom order
    const sceneName = sceneOrder[newSceneIndex].name;
    
    // Set tracking source and load the scene with sliding effect
    window.CC.pendingSceneSource = trackingSource;
    window.CC.krpano.call(
      `loadscene(${sceneName}, null, MERGE, SLIDEBLEND(1.0, ${slideDirection}, 0.5, linear))`
    );
  } else {
    // Fall back to default behavior if no custom order or insufficient scenes
    tourFunctions.nextSceneLoop(direction, trackingSource);
  }
};

tourFunctions.nextScene = (trackingSource = 'next') => {
  console.log("nextScene");
  tourFunctions.nextSceneLoop(1, trackingSource);
};

tourFunctions.prevScene = (trackingSource = 'prev') => {
  console.log("prevScene");
  tourFunctions.nextSceneLoop(-1, trackingSource);
};

tourFunctions.nextSceneWithOrder = (sceneOrder, trackingSource = 'next') => {
  console.log("nextSceneWithOrder", sceneOrder);
  tourFunctions.nextSceneLoopWithOrder(1, trackingSource, sceneOrder);
};

tourFunctions.prevSceneWithOrder = (sceneOrder, trackingSource = 'prev') => {
  console.log("prevSceneWithOrder", sceneOrder);
  tourFunctions.nextSceneLoopWithOrder(-1, trackingSource, sceneOrder);
};

tourFunctions.loadFirstScene = (trackingSource = 'krpano') => {
  window.CC.pendingSceneSource = trackingSource;
  window.CC.krpano.call("loadscene(get(scene[0].name), NULL, MERGE, SLIDEBLEND(1.0, 90, 0.5, linear) );");
};

tourFunctions.loadSceneByIndex = (index, trackingSource) => {
  window.CC.pendingSceneSource = trackingSource;
  window.CC.krpano.call(`loadscene(get(scene[${index}].name), NULL, MERGE, SLIDEBLEND(1.0, 90, 0.5, linear) )`);
};

tourFunctions.loadScene = (scene, trackingSource) => {
  let sceneName = typeof scene === "string" ? scene : scene.name;
  window.CC.pendingSceneSource = trackingSource;
  window.CC.krpano.call(
    `loadscene(${sceneName}, NULL, MERGE, SLIDEBLEND(1.0, 90, 0.5, linear) )`
  );
};

tourFunctions.parseContent = (content) => {
  if (typeof content !== "string") {
    return "";
  }
  return content.replaceAll("[", "<").replaceAll("]", ">");
};

tourFunctions.getFirstScene = () => {
  return window.CC.krpano.get("scene[0]");
};

tourFunctions.getFirstSceneName = () => {
  return window.CC.krpano.get("scene[0].name");
};
tourFunctions.getAutoNavStatus = () => {
  return !!window.CC.krpano.get("autoNavActive");
};

tourFunctions.setAutoNavInterval = (interval) => {
  window.CC.krpano.set("autoNavInterval", interval);
}

tourFunctions.startAutoNav = (interval) => {
  if (interval) window.CC.krpano.set("autoNavInterval", interval);
  window.CC.krpano.set("autoNavActive", true);
  window.CC.krpano.call("autonav()");
};

tourFunctions.stopAutoNav = () => {
  window.CC.krpano.set("autoNavActive", false);
};

tourFunctions.toggleAutoNav = () => {
  const isActive = tourFunctions.getAutoNavStatus();
  window.CC.krpano.set("autoNavActive", !isActive);
  window.CC.krpano.call("autonav()");
};

tourFunctions.currentScene = {
  getTitle: () => {
    return window.CC.krpano.get("scene[get(xml.scene)].title");
  },
  getScene: () => {
    return window.CC.krpano.get("scene[get(xml.scene)]");
  },

  getName: () => {
    return window.CC.krpano.get("xml.scene");
  },

  getIndex: () => {
    return window.CC.krpano.get("scene[get(xml.scene)].index");
  },

  getId: () => {
    return window.CC.krpano.get("scene[get(xml.scene)].id");
  },

  getHotspots: () => {
    let validStyles = ["skin_hotspotstyle", "skin_hotspotstyle_balloon"];

    let hotspots = window.CC.krpano
      .get("hotspot")
      .getArray()
      .filter((hs) => {
        return validStyles.includes(hs.style);
      });

    return hotspots;
  },

  getHotspot: (name) => {
    return window.CC.krpano.get(`hotspot[${name}]`);
  },

  getHotspotById: (id) => {
    const hotspots = window.CC.krpano.get(`hotspot`).getArray();
    return hotspots.find(hs => hs.id === id);
  },

  getGallery: (name) => {
    let galleryObj = window.CC.krpano.get(`gallery[${name}]`);
    if (galleryObj === null) {
      return null;
    }
    let gallery = galleryObj.img.getArray().map((galleryImg) => {
      return {
        src: galleryImg.url.replace("%SWFPATH%", "."),
        alt: galleryImg.alt,
      };
    });
    return gallery;
  },

  removeHotspot: (hs) => {
    window.CC.krpano.call("removehotspot(" + hs.name + ")");
  },

  getContent: () => {
    return window.CC.krpano.get("xml").content;
  },

  getLogo: () => {
    return window.CC.krpano.get("scene[get(xml.scene)].logo");
  },

  getView: () => {
    return window.CC.krpano.get("xml.view");
  },

  getCurrentView: () => {
    return window.CC.krpano.get("view");
  },

  getPosition: () => {
    let view = tourFunctions.currentScene.getCurrentView();
    let position = { ath: view.hlookat, atv: view.vlookat };
    return position;
  },
  // https://krpano.com/docu/plugininterface/#krpano.webGL.makeScreenshot
  screenshot(
    width = 0,
    height = 0,
    hotspots = false,
    type = "jpeg",
    jpegquality = 0.85,
    crop = null,
    sizeinfo = null,
    cache = null,
  ) {
    return window.CC.krpano
      .get("global")
      .webGL.makeScreenshot(
        width,
        height,
        hotspots,
        type,
        jpegquality,
        crop,
        sizeinfo,
        cache,
      );
  },
  panUp: (amount) => {
    window.CC.krpano.call(
      `calc(view.vlookat, get(view.vlookat) - ${amount} );`
    );
  },

  panDown: (amount) => {
    window.CC.krpano.call(
      `calc(view.vlookat, get(view.vlookat) + ${amount} );`
    );
  },

  panLeft: (amount) => {
    window.CC.krpano.call(
      `calc(view.hlookat, get(view.hlookat) - ${amount} );`
    );
  },

  panRight: (amount) => {
    window.CC.krpano.call(
      `calc(view.hlookat, get(view.hlookat) + ${amount} );`
    );
  },
};

tourFunctions.setupFonts = (fonts) => {
  for (let key in fonts) {
    setStyleVar(kebabCase(key), fonts[key]);
  }
};

tourFunctions.setupColors = (colors) => {
  for (let key in colors) {
    // remove alpha channel
    let colorOnly = colors[key] & 0xffffff;
    let rgb = hexToRgbString(colorOnly);
    let hex = hexToString(colors[key]);

    setStyleVar(kebabCase(key) + "-rgb", rgb);
    setStyleVar(kebabCase(key), hex);

    colors[key + "Rgb"] = rgb;
    colors[key + "Hex"] = hex;
  }
};

// Private functions
function hexToRgb(hex) {
  let r = hex >> 16;
  let g = (hex >> 8) & 0xff;
  let b = hex & 0xff;
  return [r, g, b];
}

function rgbToString(rgb) {
  return +rgb[0] + "," + rgb[1] + "," + rgb[2];
}

function hexToRgbString(hex) {
  let rgb = hexToRgb(hex);
  return rgbToString(rgb);
}

function hexToString(hex) {
  // if hex is a string (ie from json response)
  if (typeof hex === "string") {
    hex = parseInt(hex, 16);
  }
  // convert hex to string
  let str = hex.toString(16);
  // pad with leading zeros
  while (str.length < 6) {
    str = "0" + str;
  }

  // #rrggbb
  const hexColor = "#" + str.toUpperCase();
  return hexColor;
}

function setStyleVar(name, value) {
  if (!name.startsWith("--")) {
    name = "--" + name;
  }
  document.documentElement.style.setProperty(name, value);
}

function kebabCase(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
